export const breakpoints = {
  sm: "38.75em",
  md: "53.75em",
  lg: "56.25em",
  xl: "62.5em",
  "2xl": "65em",
};
